import React from 'react';
import { MobileNutritionSummary } from '@/components/nutrition/mobile/MobileNutritionSummary';
import { MobileQuickActions } from '@/components/nutrition/mobile/MobileQuickActions';
import { NutritionProvider } from '@/components/nutrition/core/NutritionProvider';

export const MobileEssentials: React.FC = () => {
  return (
    <NutritionProvider>
      <section aria-label="Daily essentials" className="md:hidden space-y-4">
        <MobileNutritionSummary />
        <MobileQuickActions />
      </section>
    </NutritionProvider>
  );
};

export default MobileEssentials;
